/**
 * Calendar Meetings Service
 * Handles fetching calendar meeting events
 */
import BaseApiService from '../base/BaseApiService';
import type { CalendarEventsResponse, CalendarEventsFilters } from '@app-types';

class CalendarMeetingsService extends BaseApiService {
  /**
   * Get calendar events within a date range
   */
  async getCalendarEvents(filters: CalendarEventsFilters): Promise<CalendarEventsResponse> {
    const params = new URLSearchParams();
    params.append('startDate', filters.startDate);
    params.append('endDate', filters.endDate);

    if (filters.includeCompleted) params.append('includeCompleted', 'true');
    if (filters.division) params.append('division', filters.division);
    if (filters.tier) params.append('tier', filters.tier);
    if (filters.assessorId) params.append('assessorId', filters.assessorId.toString());
    if (filters.status) params.append('status', filters.status);

    return this.get<CalendarEventsResponse>(`/contract-assessment-meetings/calendar?${params}`);
  }
}

const calendarMeetingsService = new CalendarMeetingsService();
export default calendarMeetingsService;
